import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import ViewPostPageNew from "../../components/Post/ViewPostPageNew";



const ApproveViewPostPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb  id="title" title2="Approve Post" link2="/approvepost" title="View Post" />

        {/* AddUserLayer */}
        <ViewPostPageNew />


      </MasterLayout>
    </>
  );
};

export default ApproveViewPostPage;
